import { render } from "./MyStudents.vue?vue&type=template&id=3c8ceaa5&scoped=true"
import script from "./MyStudents.vue?vue&type=script&lang=js"
export * from "./MyStudents.vue?vue&type=script&lang=js"

import "./MyStudents.vue?vue&type=style&index=0&id=3c8ceaa5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8ceaa5"]])

export default __exports__